export default __webpack_public_path__ + "static/media/datecalender.80dfb151.svg";